<template>
    <div id="importKateSpadeExcel">
        <a-modal
                title="Kate Spade Excel"
                :visible="visible"
                :footer="null"
                @cancel="() => (visible = false)"
        >
            <a-upload
                    :showUploadList="false"
                    :customRequest="customRequest"
                    :headers="headers"
                    :data="uploadData"
                    method="post"
                    accept=".xlsx"
                    :beforeUpload="beforeUpload"
            >
                <a-tooltip placement="topLeft">
                    <template slot="title">
                        <span>Upload</span>
                    </template>
                    <a-button type="primary" shape="circle" icon="upload" size="small"/>
                </a-tooltip>
            </a-upload>

        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import axios from 'axios'
    import cookie from "../../../api/cookie";

    export default{
        data(){
            return{
                visible: false,
                headers: {
                    "Authorization": cookie.getBearerToken()
                },
                uploadData:{}
            }
        },
        methods:{
            beforeUpload(file) {
                const isExcel = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(file.type);
                if (!isExcel) {
                    this.$customMessage.error('You can only upload Excel files (.xlsx)');
                }
                const isLt5M = file.size / 1024 / 1024 < 2;  // 限制文件大小为 5MB
                if (!isLt5M) {
                    this.$customMessage.error('File must smaller than 2MB!');
                }
                return isExcel && isLt5M;  // 返回 true 或 false 以决定是否上传
            },

            show(){
                this.visible = true
            },
            customRequest(data){
                const formData = new FormData()
                formData.append('file', data.file)
                this.$store.commit("updataLoading", { pbLoading: true });
                ajax.post(api.INPORTKATESPADEEXCEL,formData).then(res=>{
                    this.$store.commit("updataLoading", { pbLoading: false });
                    if(res.code == '200'){
                        this.$message.success(res.msg);
                         let topMenu = JSON.parse(sessionStorage.getItem("menu"))
                         let topMenuActive = sessionStorage.getItem("menuActive")
                         for(let i in topMenu){
                             if(topMenu[i].key == topMenuActive){
                                 let idStr = res.data == null ? "":res.data
                                 let array =  idStr.split(",")
                                 if (array.length <= 100) {
                                     //    return true;  // 长度小于100，符合条件
                                     topMenu[i].importUids = res.data
                                 }
                             }
                         }
                         sessionStorage.setItem("menu", JSON.stringify(topMenu));
                        this.$emit("cancelImport", "init");
                    }else{
                        // this.$customMessage.warning(res.msg);
                        this.$emit('showExcelErrorMsgBox', res.msg);
                    }
                    this.visible = false
                })
            },

            // downloadTml(){
            //     let ajaxurl = ajax.ajaxUrl();
            //     axios.get(ajaxurl + api.INVENTORYEXPORTTRANSFEREXCEL, {
            //         params: {},
            //         headers: {
            //             Authorization: cookie.getBearerToken()
            //         },
            //         responseType: "blob" //二进制流
            //     }).then(res=>{
            //         this.$store.commit("updataLoading", { pbLoading: false });
            //         let blob = new Blob([res.data], {type: "application/octet-stream;charset=UTF-8"});
            //         let url = window.URL.createObjectURL(blob);
            //         let aLink = document.createElement("a");
            //         aLink.style.display = "none";
            //         aLink.href = url;
            //         aLink.setAttribute("download", 'excel.xlsx');
            //         document.body.appendChild(aLink);
            //         aLink.click();
            //         document.body.removeChild(aLink); //下载完成移除元素
            //         window.URL.revokeObjectURL(url); //释放掉blob对象
            //     })
            // }
        }
    }
</script>